<div class="dropdown-container">
  <div *ngFor="let user of filtredUsers" [ngClass]="{ 'user-item': true, 'hightligted': user.id === selectedUser.id }" >
    <div class="user-avatar"><img [src]="user.image"></div>
    <div class="username" [innerHTML]="user.name"></div>
  </div>
</div>
